import script from "./Csitcoursemenu.vue?vue&type=script&setup=true&lang=js"
export * from "./Csitcoursemenu.vue?vue&type=script&setup=true&lang=js"

import "./Csitcoursemenu.vue?vue&type=style&index=0&id=7b3b0c7d&scoped=true&lang=css"

import exportComponent from "F:\\work\\FFSTAR3\\VUESP\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b3b0c7d"]])

export default __exports__